import { jsx as t, Fragment as A, jsxs as v } from "react/jsx-runtime";
import { useState as I, useMemo as $, useCallback as N, useLayoutEffect as C } from "react";
import n from "./styles.module.less.js";
import E from "./logo.webp.js";
import { usePathname as S } from "../../../utils/use-pathname.js";
import { AccountLink as D } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as d } from "./index.js";
import { areasOfLawData as M } from "../../../constants.js";
import { convertToKebabCase as R } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as T } from "./dropdown-menu-item/index.js";
import { MenuItem as y } from "./menu-item/index.js";
import { ForLawyersMenuButtonDesktop as B } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as H } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as P } from "./chat-button/index.js";
import { getRoute as F, RouteType as O } from "../../../utils/get-route.js";
import { LawyerViewButtons as _ } from "./lawyer-view-buttons/index.js";
const x = "/help", ae = (r) => {
  const {
    getTranslation: s,
    language: e,
    isLawyerSupported: h = !1,
    useWill: f = !1,
    lmpEnabled: p = !1,
    hideLinks: g = !1,
    lawyerView: k = !1,
    legalHubSupported: c = !1
  } = r, o = S(), [l, w] = I(!1), u = $(() => {
    const a = M[e];
    if (a)
      return [
        ...a.map((m) => ({
          ...m,
          path: `/${e}/${c ? "legal-hub" : "topics"}/${R(m.title)}`
        }))
      ];
  }, [e]), i = N(
    (a) => {
      switch (a) {
        case "/chat":
          return o === "/chat";
        case "/about":
          return o === `/${e}/about`;
        case "/about/company":
          return o === `/${e}/about/company`;
        case "/help":
          return o === x;
        case "/find":
          return o.endsWith(
            "/find"
            /* BROWSE_LAWYERS */
          );
        case "/legal-hub":
          return o === `/${e}/legal-hub`;
        case "/topics":
          return o === `/${e}/topics`;
        case "/account":
          return o === "/account";
        case "/for-lawyers/legal-network":
          return o === `/${e}/for-lawyers/legal-network`;
        case "/make-a-will":
          return o === F(O.WILL_INFO);
        default:
          return !1;
      }
    },
    [o, u, e]
  );
  return C(() => {
    const a = () => {
      var b, L;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((b = document.getElementById(d)) == null || b.classList.add(n.shrink), w(!0)) : ((L = document.getElementById(d)) == null || L.classList.remove(n.shrink), w(!1));
    };
    return window.addEventListener("scroll", a), document.body.addEventListener("scroll", a), a(), () => {
      window.removeEventListener("scroll", a), document.body.removeEventListener("scroll", a);
    };
  }, []), /* @__PURE__ */ t(A, { children: /* @__PURE__ */ t("div", { className: n.floatingContainer, id: d, children: /* @__PURE__ */ v("div", { className: n.menuContentContainer, children: [
    /* @__PURE__ */ t(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: n.logoContainer,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: E,
            alt: "LawConnect Logo",
            width: 0,
            height: 20,
            className: n.logo
          }
        )
      }
    ),
    !g && k ? /* @__PURE__ */ t(
      _,
      {
        language: e,
        environment: r.environment
      }
    ) : !g && /* @__PURE__ */ v("div", { className: n.menuLinksContainer, children: [
      h ? /* @__PURE__ */ t(
        H,
        {
          language: e,
          titleLabel: s("pages.get-help"),
          getTranslation: s,
          hasShrunk: l,
          isLawyerSupported: !0,
          onRequestLawyer: r.onRequestLawyer,
          isActive: i(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ t(
        P,
        {
          getTranslation: s,
          isScrolledHeader: l
        }
      ),
      h ? null : /* @__PURE__ */ t("div", { className: n.spacer }),
      p ? /* @__PURE__ */ t(
        y,
        {
          label: "Browse lawyers",
          path: e ? `/${e}/find` : "/find",
          hasShrunk: l,
          isActive: i(
            "/find"
            /* BROWSE_LAWYERS */
          )
        }
      ) : null,
      u ? /* @__PURE__ */ t(
        T,
        {
          language: e,
          items: u,
          titleLabel: c ? "Legal hub" : s("pages.legal-topics"),
          hasShrunk: l,
          link: c ? `/${e}/legal-hub` : `/${e}/topics`,
          classNames: {
            container: n.subMenuContainer,
            itemRow: n.offsetDropdownItemRow
          },
          isActive: i(
            c ? "/legal-hub" : "/topics"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      p ? null : /* @__PURE__ */ t(
        y,
        {
          label: s("pages.about"),
          path: `/${e}/about/company`,
          hasShrunk: l,
          isActive: i(
            "/about/company"
            /* ABOUT_COMPANY */
          )
        }
      ),
      /* @__PURE__ */ t(
        B,
        {
          language: e,
          getTranslation: s,
          useWill: f,
          isScrolledHeader: l,
          isActive: i(
            f ? "/make-a-will" : "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          ),
          environment: r.environment
        }
      ),
      /* @__PURE__ */ t(
        D,
        {
          isScrolledHeader: l,
          isActive: i(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: r.isAuthenticated,
          userImage: r.userImage,
          openAuthModal: r.openAuthModal,
          logout: r.logout,
          hasNotifications: r.hasNotifications,
          language: e,
          getTranslation: s
        }
      )
    ] })
  ] }) }) });
};
export {
  ae as DesktopMenu
};
